import { render, staticRenderFns } from "./LoginPortal.vue?vue&type=template&id=5d73793a&scoped=true&"
import script from "./LoginPortal.vue?vue&type=script&lang=js&"
export * from "./LoginPortal.vue?vue&type=script&lang=js&"
import style0 from "./LoginPortal.vue?vue&type=style&index=0&id=5d73793a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73793a",
  null
  
)

export default component.exports